import React from "react"
import styled from "styled-components"

export const Main = styled.main`
	display: flex;
	flex-direction: column;
`
export const MainInnerWrap = styled.div`
	width: 100%;
	max-width: 60rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
`
export const Header = styled.header`
	font-family: FuturaMedium;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	padding: 1rem;

	@media (min-width: 800px) {
		& {
			margin-bottom: 2rem;
		}
	}
`
export const Row = styled.div`
	display: flex;
	align-items: center;
`
const Icon = styled.img`
	width: 6rem;
	height: 6rem;
	object-fit: contain;
	margin-right: 1rem;
`
export const PageTitle = styled.h1`
	font-size: 1.75rem;

	@media (min-width: 800px) {
		& {
			font-size: 2rem;
		}
	}
`
const Bold = styled.span`
	font-family: FuturaBold;
`
export const PageSubTitle = styled.div`
	text-align: center;
	font-size: 1.125rem;
	font-family: FuturaMediumItalic;
`
export const LoginButton = styled.a`
	display: block;
	color: white;
	background: #0DA4F0;
	cursor: pointer;
	padding: 0.5rem 1rem;
	text-decoration: none;
	border-radius: 6px;
	font-size: 1.125rem;
	margin: 1rem 0 0 0;

	@media (min-width: 800px) {
		& {
			position: absolute;
			top: 1rem;
			right: 1rem;
			margin: 0;
		}
	}
`
const ExternalLoginButton = styled.a`
	display: block;
	color: white;
	background: #0d18f0;
	cursor: pointer;
	padding: 0.5rem 1rem;
	text-decoration: none;
	border-radius: 6px;
	font-size: 1.125rem;
	margin: 1rem 0 0 0;

	@media (min-width: 800px) {
		& {
			position: absolute;
			top: 4rem;
			right: 1rem;
			margin: 0;
		}
	}
`

const MISightButton = styled.a`
	display: block;
	color: white;
	background: #0bbf64;
	cursor: pointer;
	padding: 0.5rem 1rem;
	text-decoration: none;
	border-radius: 6px;
	font-size: 1.125rem;
	margin: 1rem 0 0 0;

	@media (min-width: 800px) {
		& {
			position: absolute;
			top: 7rem;
			right: 1rem;
			margin: 0;
		}
	}
`

export const HeroImage = styled.img`
	width: 100%;
	height: auto;
	object-fit: cover;
	object-position: center top;
	margin-bottom: 3.75rem;

	@media (min-width: 800px) {
		& {
			max-width: 45rem;
			max-height: 80vh;
			border-radius: 60px;
			box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 10px 50px 20px rgba(0, 0, 0, 0.1);
		}
	}
`
export const HR = styled.hr`
	border: 0;
	height: 1px;
	width: 100%;
	max-width: 400px;
	background: linear-gradient(to right, rgba(187,187,187,0), rgba(187,187,187,1), rgba(187,187,187,0));
	margin-bottom: 3rem;
`
export const Section = styled.section`
	margin-bottom: 3rem;
	padding: 0 1.5rem 0 1.5rem;
	width: 100%;
	max-width: 48rem;
`
export const SectionTitle = styled.h2`
	margin-bottom: 2.5rem;
	font-family: FuturaBold;
	font-size: ${({ fontSize }) => fontSize || '1.5rem'};
	text-align: center;
`
export const Paragraph = styled.p`
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
	line-height: 1.75;
	font-size: 1.125rem;
	margin-bottom: 1.5rem;
	
	&:last-child {
		margin-bottom: 0;
	}
`
export const LinkText = styled.a`
	color: #0DA4F0;
	text-decoration: none;
`
export const People = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 2.5rem;
	padding: 0 1rem;
	justify-content: space-between;

	&:last-child {
		margin-bottom: 0;
	}

	@media (min-width: 800px) {
		& {
			flex-direction: row;
		}
	}
`
export const Person = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 2rem;
	
	&:not(:last-child) {
		margin-right: 2rem;
	}
	
	&:last-child {
		margin-bottom: 0;
	}

	@media (min-width: 800px) {
		& {
			margin-bottom: 0;
		}
	}
`
export const Portrait = styled.img`
	width: 250px;
	height: 350px;
	border-radius: 18px;
	object-fit: cover;
	object-position: center center;
	margin-bottom: 1rem;
`
export const PersonTitle = styled.div`
	font-family: FuturaMediumItalic;
	font-size: 1.125rem;
	line-height: 1.5;
`
export const PersonSubTitle = styled.div`
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
	font-size: 0.875rem;
	line-height: 1.5;
	text-rendering: optimizeLegibility;
	text-align: center;
`
const Footnote = styled.div`
	margin-bottom: 3rem;
	width: 100%;
	padding: 1rem;
	text-align: center;
	line-height: 2;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`
export const Copyright = styled.div`
	font-family: FuturaMedium;
	text-align: center;
	line-height: 2;
	color: #aaa;
	font-size: 0.75rem;
`

export default function LandingPage() {
	return (
		<Main>
			<MainInnerWrap>
				<Header>
					<Row>
						<Icon src="/images/icon.png" />
						<PageTitle>
							<Bold>S</Bold>upport, <Bold>E</Bold>ducate, <Bold>E</Bold>mpower
						</PageTitle>
					</Row>
					<PageSubTitle>The SEE Personalized Glaucoma Coaching Trial</PageSubTitle>
					<LoginButton href="/login">Login</LoginButton>
					<ExternalLoginButton href="/external-login">External Login</ExternalLoginButton>
					<MISightButton href="/mi-sight">Visit MI-Sight</MISightButton>
				</Header>
				<HeroImage src="/images/riding-bikes.jpg" />
				<HR />
				<Section>
					<SectionTitle>What is the SEE Program?</SectionTitle>
					<Paragraph>To preserve sight, glaucoma patients must take the eye drops recommended by their doctor. And yet, 80% of patients do not consistently take their medications. The Support, Educate, Empower (SEE) Personalized Glaucoma Coaching Program combines personalized support from a trained glaucoma coach with individualized education and reminders to try to better support people in taking control of their glaucoma by taking their eye drops on time every day.</Paragraph>
				</Section>
				<Section>
					<SectionTitle>What is the SEE Program Trial?</SectionTitle>
					<Paragraph>To understand whether the SEE Program improves glaucoma medication adherence, we will compare the SEE Program to standard glaucoma education in a randomized controlled trial. A randomized controlled trial is a study in which people are allocated randomly (by chance alone) to receive a new intervention or the standard intervention. This is the best research method to understand whether a new intervention is effective compared to the standard intervention. After the completion of the SEE Program randomized controlled trial, we will know whether to recommend the SEE Program as the new “standard of care” for glaucoma patients to policy makers. To find out more about the trial, visit <LinkText href="https://clinicaltrials.gov/ct2/show/NCT04735653?cond=glaucoma&cntry=US&state=US%3AMI&draw=2&rank=3">ClinicalTrials.gov</LinkText>.</Paragraph>
				</Section>
				<Section>
					<SectionTitle>Why participate in the SEE Program Trial?</SectionTitle>
					<Paragraph>Participating in research can help you and gives you an opportunity to help many others. Participants in the SEE Program trial will receive the best educational information currently available. By participating in the trial, you will help researchers and health policy makers understand whether paying for personalized glaucoma coaching would help people better take control of their glaucoma and stop glaucoma-related vision loss.</Paragraph>
				</Section>
				<Section>
					<SectionTitle>SEE Program Publications</SectionTitle>
					<Paragraph><LinkText href="/publications" target="_blank">Click to see the SEE Program Publications</LinkText></Paragraph>
				</Section>
				<Section>
					<SectionTitle>How can I participate in the SEE Program Trial?</SectionTitle>
					<Paragraph>To participate in the program, please let us know by contacting one of the study locations below.</Paragraph>
				</Section>
				<HR />
				<Section>
					<SectionTitle>Study Locations</SectionTitle>
					<Paragraph><strong>University of Michigan Kellogg Eye Center – Ann Arbor, Michigan</strong><br />Phone: (734) 249-9987<br />Email: <LinkText href="mailto:theseeprogram2020@gmail.com">theseeprogram2020@gmail.com</LinkText></Paragraph>
					<People>
						<Person>
							<Portrait src="/images/people/paula-anne.jpg" />
							<PersonTitle>Paula Anne Newman-Casey, MD, MS</PersonTitle>
							<PersonSubTitle>Principal Investigator, SEE Study</PersonSubTitle>
							<PersonSubTitle>Glaucoma Specialist</PersonSubTitle>
							<PersonSubTitle>Department of Ophthalmology & Visual Sciences</PersonSubTitle>
						</Person>
						<Person>
							<Portrait src="/images/people/phalatha.jpg" />
							<PersonTitle>Phalatha McHaney-Conner</PersonTitle>
							<PersonSubTitle>Glaucoma Counselor, SEE Study</PersonSubTitle>
							<PersonSubTitle>Clinical Research Coordinator</PersonSubTitle>
							<PersonSubTitle>Department of Ophthalmology & Visual Sciences</PersonSubTitle>
						</Person>
						<Person>
							<Portrait src="/images/people/asia.jpg" />
							<PersonTitle>Asia Priester</PersonTitle>
							<PersonSubTitle>Glaucoma Counselor, SEE Study</PersonSubTitle>
							<PersonSubTitle>Clinical Research Coordinator</PersonSubTitle>
							<PersonSubTitle>Department of Ophthalmology & Visual Sciences</PersonSubTitle>
						</Person>
					</People>
					<Paragraph><strong>Henry Ford Health System – Detroit, Michigan</strong><br />Phone: (313) 389-6678<br />Email: <LinkText href="mailto:hftheseeprogram2020@gmail.com">hftheseeprogram2020@gmail.com</LinkText></Paragraph>
					<People>
						<Person>
							<Portrait src="/images/people/deborah.jpg" />
							<PersonTitle>Deborah Darnley-Fisch, MD</PersonTitle>
							<PersonSubTitle>Site Investigator, SEE Study</PersonSubTitle>
							<PersonSubTitle>Glaucoma Specialist</PersonSubTitle>
							<PersonSubTitle>Department of Ophthalmology</PersonSubTitle>
						</Person>
					</People>
				</Section>
				<HR />
				<Footnote>
					<div>The SEE Program trial is funded by the <LinkText href="https://www.nei.nih.gov">National Eye Institute</LinkText></div>
					<div style={{ fontSize: "0.875rem" }}>(Grant number R01EY031337-01)</div>
				</Footnote>
				<Copyright>© 2025 The University of Michigan – All Rights Reserved</Copyright>
			</MainInnerWrap>
		</Main>
	)
}



// WEBPACK FOOTER //
// ./src/pages/Landing/index.js